import { render, staticRenderFns } from "./onDcode.vue?vue&type=template&id=36d40568&"
import script from "./onDcode.vue?vue&type=script&lang=js&"
export * from "./onDcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports